/*
 * @Description: 小票默认配置数据
 * @Author: Roger Wei
 * @Date: 2021-11-28 15:57:53
 * @LastEditTime: 2023-11-13 17:21:46
 * @LastEditors: 刘小二
 * @CopyRight: itence.com
 * @Reference: 
 */

export default [
    {
        key: 'weigthTicket',
        label: '过磅小票',
        children: [
            {
                key: 'rawSupply',
                label: '原物料供货',
                conditionList: [
                    {  key: 'contractSigningSubject',  label: '合同签订主体', remark: '请录入合同主体名称'},
                    {  key: 'isFirstSupply',  label: '是否甲供', remark: '请输入Y/N'},
                    {  key: 'supplier',  label: '供应商', remark: '请输入供应商名称'},
                    {  key: 'rawName',  label: '原物料', remark: '请输入原物料名称'},
                    {  key: 'specification',  label: '规格', remark: '请输入规格名称'},
                    {  key: 'brand',  label: '品牌', remark: '请输入品牌名称'},
                    {  key: 'originPlace',  label: '产地', remark: '请输入产地名称'},
                    {  key: 'transportUnit',  label: '运输单位', remark: '请输入运输单位'},
                    {  key: 'contractSigningSubject2',  label: '合同签订主体（备用）', remark: '请录入合同主体名称'},
                    {  key: 'contractSigningSubject1',  label: '需求主体', remark: '请录入需求主体名称'},
                ],
                dataSourceList: [
                    {  key: 'contractSigningSubject',  label: '合同签订主体'},
                    {  key: 'code',  label: '单据号'},
                    {  key: 'receiveStation',  label: '收货单位'},
                    {  key: 'isFirstSupply',  label: '是否甲供'},
                    {  key: 'cooperativeUnit',  label: '协作单位'},
                    {  key: 'supplier',  label: '供应商'},
                    {  key: 'rawName',  label: '原物料'},
                    {  key: 'specification',  label: '规格'},
                    {  key: 'brand',  label: '品牌'},
                    {  key: 'originPlace',  label: '产地'},
                    {  key: 'transportUnit',  label: '运输单位'},
                    {  key: 'userRealName', label: '当前登录账号名称' }, 
                    {  key: 'deliveryVehicl', label: '车牌号' }, 
                    {  key: 'firstWeight', label: '毛重' }, 
                    {  key: 'secondWeight', label: '皮重' }, 
                    {  key: 'netWeight', label: '净重' }, 
                    {  key: 'moistureContent', label: '含水率' }, 
                    {  key: 'deductionWaterNum', label: '含水扣减量' }, 
                    {  key: 'exceptionDeduction', label: '异常扣减量' }, 
                    {  key: 'receiveVolume', label: '收货量' }, 
                    {  key: 'remark', label: '备注' }, 
                    {  key: 'firstTime', label: '第一次过磅时间' }, 
                    {  key: 'secondTime', label: '第二次过磅时间' }, 
                    {  key: 'repertory',  label: '库存仓'},
                    {  key: 'contractSigningSubject1',  label: '需求主体'},
                    {  key: 'contractSigningSubject2',  label: '合同签订主体（备用）'},
                ]
            },
            {
                key: 'TankerOut',
                label: '罐车出站',
                conditionList: [
                    { key: 'customerName', label: '客户名称', remark: '请输入客户名称' },
                    { key: 'projectName', label: '工程名称', remark: '请输入工程名称' }, 
                    { key: 'pourPosition', label: '浇筑部位', remark: '请输入浇筑部位名称' }, 
                    { key: 'pourMode', label: '浇筑方式', remark: '请输入浇筑方式名称' }, 
                    { key: 'productionLine', label: '生产线', remark: '请输入生产线名称' }, 
                    { key: 'dutySite', label: '责任站点', remark: '请输入责任站点名称' }, 
                    { key: 'serviceContact', label: '合同签订主体', remark: '请输入合同签订主体名称' }, 
                    { key: 'strengthGrade', label: '强度等级', remark: '请输入强度等级名称' }, 
                ],
                dataSourceList: [
                    { key: 'customerName', label: '客户名称' },
                    { key: 'code',  label: '单据号'},
                    { key: 'projectName', label: '工程名称' }, 
                    { key: 'pourPosition', label: '浇筑部位' }, 
                    { key: 'pourMode', label: '浇筑方式' }, 
                    { key: 'productionLine', label: '生产线' }, 
                    { key: 'dutySite', label: '生产站点' }, 
                    { key: 'serviceContact', label: '合同签订主体' }, 
                    { key: 'strengthGrade', label: '强度等级' }, 
                    { key: 'productionVolume', label: '生产方量' }, 
                    { key: 'faceValue', label: '票面量' }, 
                    { key: 'carNo', label: '车牌号' }, 
                    { key: 'weightTime', label: '过磅时间' },
                    { key: 'grossWeight', label: '毛重' },
                    { key: 'tareWeight', label: '皮重' },
                    { key: 'netWeight', label: '净重' },
                    { key: 'userRealName', label: '当前登录账号名称' }, 
                    { key: 'weightTime2', label: '过磅日期' },
                    { key: 'driver', label: '司机' }, 
                    { key: 'driverPhone', label: '司机电话' },
                ]
            },
            {
                key: 'TankerIn',
                label: '罐车回站',
                conditionList: [
                    { key: 'customerName', label: '客户名称', remark: '请输入客户名称' },
                    { key: 'projectName', label: '工程名称', remark: '请输入工程名称' }, 
                    { key: 'pourPosition', label: '浇筑部位', remark: '请输入浇筑部位名称' }, 
                    { key: 'pourMode', label: '浇筑方式', remark: '请输入浇筑方式名称' }, 
                    { key: 'productionLine', label: '生产线', remark: '请输入生产线名称' }, 
                    { key: 'dutySite', label: '责任站点', remark: '请输入责任站点名称' }, 
                    { key: 'serviceContact', label: '合同签订主体', remark: '请输入合同签订主体名称' }, 
                    { key: 'strengthGrade', label: '强度等级', remark: '请输入强度等级名称' }, 
                ],
                dataSourceList: [
                    { key: 'customerName', label: '客户名称' },
                    { key: 'code',  label: '单据号'},
                    { key: 'projectName', label: '工程名称' }, 
                    { key: 'pourPosition', label: '浇筑部位' }, 
                    { key: 'pourMode', label: '浇筑方式' }, 
                    { key: 'productionLine', label: '生产线' }, 
                    { key: 'dutySite', label: '责任站点' }, 
                    { key: 'serviceContact', label: '合同签订主体' }, 
                    { key: 'strengthGrade', label: '强度等级' }, 
                    { key: 'productionVolume', label: '生产方量' }, 
                    { key: 'faceValue', label: '票面量' }, 
                    { key: 'carNo', label: '车牌号' }, 
                    { key: 'weightTime', label: '过磅时间' },
                    { key: 'grossWeight', label: '毛重' },
                    { key: 'tareWeight', label: '皮重' },
                    { key: 'netWeight', label: '净重' },
                    { key: 'userRealName', label: '当前登录账号名称' }, 
                ]
            },
            {
                key: 'tankerTare',
                label: '罐车皮重',
                conditionList: [
                    { key: 'serviceContract', label: '运输合同单位', remark: '请输入运输合同单位名称' }, 
                    { key: 'carType', label: '车辆类型', remark: '请输入车辆类型名称' }, 
                    { key: 'belongSite', label: '所属站点', remark: '请输入所属站点名称' }, 
                ],
                dataSourceList: [
                    { key: 'serviceContract', label: '运输合同单位' }, 
                    { key: 'code',  label: '单据号'},
                    { key: 'carType', label: '车辆类型' }, 
                    { key: 'belongSite', label: '所属站点' }, 
                    { key: 'grossWeight', label: '车辆皮重' }, 
                    { key: 'faceValue', label: '票面量' }, 
                    { key: 'carNo', label: '车牌号' }, 
                    { key: 'weightTime', label: '过磅时间' },
                    { key: 'currentTareWeight', label: '本次皮重' },
                    { key: 'userRealName', label: '当前登录账号名称' }, 
                ]
            },
            {
                key: 'specialMaterialIn',
                label: '特材入库',
                conditionList: [
                    { key: 'name', label: '特材成名名称', remark: '请输入特材成名名称' }, 
                    { key: 'model', label: '产品型号', remark: '请输入产品型号名称' }, 
                    { key: 'demandSite', label: '需求站点', remark: '请输入需求站点名称' }, 
                ],
                dataSourceList: [
                    // { key: 'supplier', label: '供应商' }, 
                    {  key: 'neddSubject',  label: '需求主体'},
                    { key: 'code',  label: '单据号'},
                    { key: 'receivingSite', label: '收料站点即过磅站点' }, 
                    { key: 'name', label: '特材成名名称' }, 
                    { key: 'model', label: '产品型号' }, 
                    { key: 'demandSite', label: '需求站点' }, 
                    {  key: 'carNo', label: '车牌号' }, 
                    {  key: 'grossWeight', label: '毛重' }, 
                    {  key: 'tare', label: '皮重' }, 
                    {  key: 'suttle', label: '净重' }, 
                    {  key: 'receiveVolume', label: '收货量' }, 
                    {  key: 'remark', label: '备注' }, 
                    {  key: 'firstWeightTime', label: '第一次过磅时间' }, 
                    {  key: 'secondWeightTime', label: '第二次过磅时间' }, 
                    { key: 'userRealName', label: '当前登录账号名称' }, 
                ]
            },
            {
                key: 'specialMaterialOutbound',
                label: '特材出库',
                conditionList: [
                    { key: 'name', label: '特材成名名称', remark: '请输入特材成名名称' }, 
                    { key: 'productType', label: '产品型号', remark: '请输入产品型号名称' }, 
                    { key: 'demandSite', label: '需求站点', remark: '请输入需求站点名称' }, 
                ],
                dataSourceList: [
                    // { key: 'supplier', label: '供应商' }, 
                    {  key: 'neddSubject',  label: '需求主体'},
                    { key: 'code',  label: '单据号'},
                    { key: 'receivingSite', label: '收料站点即过磅站点' }, 
                    { key: 'name', label: '特材成名名称' }, 
                    { key: 'productType', label: '产品型号' }, 
                    { key: 'demandSite', label: '需求站点' }, 
                    {  key: 'carNo', label: '车牌号' }, 
                    {  key: 'grossWeight', label: '毛重' }, 
                    {  key: 'tare', label: '皮重' }, 
                    {  key: 'suttle', label: '净重' }, 
                    {  key: 'receiveVolume', label: '收货量' }, 
                    {  key: 'remark', label: '备注' }, 
                    {  key: 'firstWeightTime', label: '第一次过磅时间' }, 
                    {  key: 'secondWeightTime', label: '第二次过磅时间' }, 
                    { key: 'userRealName', label: '当前登录账号名称' }, 
                ]
            },
            {
                key: 'specialMaterialOut',
                label: '特材返料',
                conditionList: [
                    { key: 'name', label: '特材成名名称', remark: '请输入特材成名名称' }, 
                    { key: 'model', label: '产品型号', remark: '请输入产品型号名称' }, 
                    { key: 'demandSite', label: '需求站点', remark: '请输入需求站点名称' }, 
                ],
                dataSourceList: [
                    // { key: 'supplier', label: '供应商' }, 
                    { key: 'code',  label: '单据号'},
                    { key: 'name', label: '特材成名名称' }, 
                    { key: 'model', label: '产品型号' }, 
                    { key: 'demandSite', label: '需求站点' }, 
                    {  key: 'carNo', label: '车牌号' }, 
                    {  key: 'grossWeight', label: '毛重' }, 
                    {  key: 'tare', label: '皮重' }, 
                    {  key: 'suttle', label: '净重' }, 
                    {  key: 'receiveVolume', label: '收货量' }, 
                    {  key: 'remark', label: '备注' }, 
                    {  key: 'firstWeightTime', label: '第一次过磅时间' }, 
                    {  key: 'secondWeightTime', label: '第二次过磅时间' }, 
                    { key: '12', label: '当前登录账号名称' }, 
                ]
            },
            {
                key: 'rawTransferOut',
                label: '原物料调出',
                conditionList: [
                    { key: 'rawContractCompany', label: '原物料合同单位', remark: '请输入原物料合同单位名称' }, 
                    { key: 'carOutsourceContractCompany', label: '车辆外包合同单位', remark: '请输入车辆外包合同单位名称' }, 
                    { key: 'raw', label: '原物料', remark: '请输入原物料名称' }, 
                    { key: 'specification', label: '规格', remark: '请输入规格名称' }, 
                    { key: 'brand', label: '品牌', remark: '请输入品牌名称' }, 
                    { key: 'originPlace', label: '产地', remark: '请输入产地名称' }, 
                    { key: 'transferOutSite', label: '调出站点', remark: '请输入调出站点名称' }, 
                    { key: 'transferInSite', label: '调入站点', remark: '请输入调入站点名称' }, 
                ],
                dataSourceList: [
                    { key: 'rawContractCompany', label: '原物料合同单位' }, 
                    { key: 'code',  label: '单据号'},
                    { key: 'carOutsourceContractCompany', label: '车辆外包合同单位' }, 
                    { key: 'raw', label: '原物料' }, 
                    { key: 'specification', label: '规格' }, 
                    { key: 'brand', label: '品牌' }, 
                    { key: 'originPlace', label: '产地' }, 
                    { key: 'transferOutSite', label: '调出站点' }, 
                    { key: 'transferInSite', label: '调入站点' }, 
                    {  key: 'carNo', label: '车牌号' }, 
                    {  key: 'grossWeight', label: '毛重' }, 
                    {  key: 'tare', label: '皮重' }, 
                    {  key: 'suttle', label: '净重' }, 
                    {  key: 'confirmVolume', label: '调拨确认量' }, 
                    {  key: 'remark', label: '备注' }, 
                    {  key: 'firstWeightTime', label: '第一次过磅时间' }, 
                    {  key: 'secondWeightTime', label: '第二次过磅时间' }, 
                ]
            },
            {
                key: 'rawTransferIn',
                label: '原物料调入',
                conditionList: [
                    { key: 'rawContractCompany', label: '原物料合同单位', remark: '请输入原物料合同单位名称' }, 
                    { key: 'carOutsourceContractCompany', label: '车辆外包合同单位', remark: '请输入车辆外包合同单位名称' }, 
                    { key: 'raw', label: '原物料', remark: '请输入原物料名称' }, 
                    { key: 'specification', label: '规格', remark: '请输入规格名称' }, 
                    { key: 'brand', label: '品牌', remark: '请输入品牌名称' }, 
                    { key: 'originPlace', label: '产地', remark: '请输入产地名称' }, 
                    { key: 'transferOutSite', label: '调出站点', remark: '请输入调出站点名称' }, 
                    { key: 'transferInSite', label: '调入站点', remark: '请输入调入站点名称' }, 
                ],
                dataSourceList: [
                    { key: 'rawContractCompany', label: '原物料合同单位' }, 
                    { key: 'code',  label: '单据号'},
                    { key: 'carOutsourceContractCompany', label: '车辆外包合同单位' }, 
                    { key: 'raw', label: '原物料' }, 
                    { key: 'specification', label: '规格' }, 
                    { key: 'brand', label: '品牌' }, 
                    { key: 'originPlace', label: '产地' }, 
                    { key: 'transferOutSite', label: '调出站点' }, 
                    { key: 'transferInSite', label: '调入站点' }, 
                    {  key: 'carNo', label: '车牌号' }, 
                    {  key: 'grossWeight', label: '毛重' }, 
                    {  key: 'tare', label: '皮重' }, 
                    {  key: 'suttle', label: '净重' }, 
                    {  key: 'confirmVolume', label: '调拨确认量' }, 
                    {  key: 'remark', label: '备注' }, 
                    {  key: 'firstWeightTime', label: '第一次过磅时间' }, 
                    {  key: 'secondWeightTime', label: '第二次过磅时间' },  
                ]
            },
            {
                key: 'sellMaterial',
                label: '售料',
                conditionList: [
                ],
                dataSourceList: [
                    { key: 'stationName', label: '站点' }, 
                    { key: 'rawName',  label: '原物料'},
                    { key: 'specification', label: '规格' }, 
                    { key: 'brand', label: '品牌' }, 
                    { key: 'originPlace', label: '产地' }, 
                    { key: 'shipTo', label: '收货方' }, 
                    { key: 'carNo', label: '车牌号' }, 
                    {  key: 'firstWeight', label: '毛重' }, 
                    {  key: 'secondWeight', label: '皮重' }, 
                    {  key: 'netWeight', label: '净重' }, 
                    {  key: 'firstTime', label: '第一次过磅时间' }, 
                    {  key: 'secondTime', label: '第二次过磅时间' },  
                    {  key: 'moistureContent ', label: '含水率' }, 
                    {  key: 'deductionWaterNum', label: '含水扣减量' }, 
                    {  key: 'deductionExceptionNum', label: '异常扣减量' }, 
                    {  key: 'sellMaterialsNum', label: '售料量' }, 
                    {  key: 'userName', label: '当前登录账号名称' },  
                ]
            },
            {
                key: 'returnGood',
                label: '退货',
                conditionList: [
                ],
                dataSourceList: [
                    { key: 'stationName', label: '站点' }, 
                    { key: 'rawName',  label: '原物料'},
                    { key: 'specification', label: '规格' }, 
                    { key: 'brand', label: '品牌' }, 
                    { key: 'originPlace', label: '产地' }, 
                    { key: 'carNo', label: '车牌号' }, 
                    {  key: 'firstWeight', label: '毛重' }, 
                    {  key: 'secondWeight', label: '皮重' }, 
                    { key: 'remark', label: '备注' }, 
                    { key: 'rerutnGoodNum', label: '退货量' }, 
                    {  key: 'firstTime', label: '第一次过磅时间' }, 
                    {  key: 'secondTime', label: '第二次过磅时间' },  
                    {  key: 'repertory', label: '库存仓' },  
                    {  key: 'tansportUnit', label: '运输单位' }, 
                    {  key: 'userName', label: '当前登录账号名称' },  
                    { key: 'contractSigningSubject', label: '合同签订主体' }, 
                    {  key: 'whetheSupply', label: '是否甲供' }, 
                    {  key: 'supplerName', label: '供应商' },
                    {  key: 'netWeight', label: '净重' }, 
                    {  key: 'moistureContent ', label: '含水率' }, 
                    {  key: 'deductionWaterNum', label: '含水扣减量' }, 
                    {  key: 'deductionExceptionNum', label: '异常扣减量' }, 

                ]
            }
        ]
    },
    {
        key: 'concreteCarTicketMain',
        label: '混凝土司机小票',
        children: [
            {
                key: 'concreteDriverTicket',
                label: '混凝土司机小票',
                conditionList: [
                    { key: 'customerName', label: '客户名称', remark: '请输入客户名称' }, 
                    { key: 'projectName', label: '工程名称', remark: '请输入工程名称' }, 
                    { key: 'pourPositon', label: '浇筑部位', remark: '请输入浇筑部位名称' }, 
                    { key: 'pourMode', label: '浇筑方式', remark: '请输入浇筑方式名称' }, 
                    { key: 'productionLine', label: '生产线', remark: '请输入生产线名称' }, 
                    { key: 'dutySite', label: '责任站点', remark: '请输入责任站点名称' }, 
                    { key: 'serviceContract', label: '合同签订主体', remark: '请输入合同签订主体名称' }, 
                    { key: 'strengthGrade', label: '强度等级', remark: '请输入强度等级名称' }, 
                ],
                dataSourceList: [
                    // { key: 'customerName', label: '客户名称' }, 
                    { key: 'proTime', label: '发货时间' }, 
                    { key: 'proTimeDate', label: '发货时间-日期' }, 
                    { key: 'proTimeTime', label: '发货时间-时间' }, 
                    { key: 'codeUrl', label: '二维码' }, 
                    { key: 'code',  label: '单据号'},
                    { key: 'engineeringName', label: '工程名称' }, 
                    { key: 'receiver', label: '签收人' }, 
                    { key: 'structuralParts', label: '浇筑部位' }, 
                    { key: 'productName', label: '砼标号' }, 
                    { key: 'pouringMethod', label: '浇筑方式' }, 
                    { key: 'faceValue', label: '票面量' }, 
                    { key: 'cumulativeTrains', label: '累计车数' }, 
                    { key: 'carNo', label: '车牌号' }, 
                    { key: 'driverName', label: '司机名称' }, 
                    // { key: 'projectName', label: '工程名称' }, 
                    { key: 'productionVolume', label: '生产方量' }, 
                    { key: 'productionTime', label: '生产时间' }, 
                    // { key: 'pourPositon', label: '浇筑部位' }, 
                    // { key: 'pourMode', label: '浇筑方式' }, 
                    { key: 'productionLine', label: '生产线' }, 
                    { key: 'dutySite', label: '生产站点' }, 
                    { key: 'serviceContract', label: '合同签订主体' }, 
                    { key: 'strengthGrade', label: '强度等级' },
                    { key: 'orderNo', label: '订单编号' }, 
                    // { key: 'totalTransportCars', label: '累计车数' }, 
                    { key: 'totalVolume', label: '累计方量' }, 
                    { key: 'remark', label: '备注' }, 
                    { key: 'loginName', label: '当前登录账号名称' }, 
                    { key: 'constructionCompany', label: '施工单位' }, 
                    { key: 'constructionUnit', label: '供货单位' }, 
                    { key: 'contractNo', label: '合同编号' }, 
                    { key: 'customerName', label: '客户单位' }, 
                    { key: 'slumps', label: '坍落度' }, 
                    { key: 'meterialRequirements', label: '材料要求' }, 
                    { key: 'admixtureRequirements', label: '外加剂要求' }, 
                    { key: 'signature', label: '工地签收人' }, 
                    { key: 'ticketCodeX', label: '外协小票单据号' }, 
                    { key: 'concreteMarkingX', label: '混凝土标记' }, 
                    { key: 'phone', label: '联系电话' }, 
                    { key: 'people', label: '联系人' }, 
                    { key: 'orderRemark', label: '客户备注' }, 
                    { key: 'planNum', label: '本次订单量' }, 
                    { key: 'haulDistance', label: '运距' }, 
                    { key: 'pumpingUnit', label: '泵送单位' }, 
                    { key: 'engineeringPhone', label: '联系电话(履约)' }, 
                    { key: 'engineeringPeople', label: '联系人(履约)' }, 
                    { key: 'carCompany', label: '车辆所属公司(车辆供应商)' }, 
                    { key: 'serialNumber', label: '流水号（erp）' }, 
                    { key: 'chongqingQR', label: '二维码(重庆)' }, 
                    { key: 'operator', label: '操作员' }, 
                    { key: 'foreman', label: '前场工长' }, 
                ]
            }
        ]
    }
]